export enum PaymentSettingsPath {
  AUTOMATIC_PAYMENT = '/automatic-payment',
  REMOTE_PAYMENT = '/remote-payment',
  PAYMENT_WAYS = '/payment-ways',
  CURRENCY = '/currency',
  FIELD = '/field',
  CASHBACK = '/cashback',
  REQUIRED_CUSTOMER = '/required-customer'
}
